export default __webpack_public_path__ + "static/media/play.f190d02c.svg";